<kt-base-modal [title]="'Rewards'">
  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div class="rewards-list">
        <div class="r-list-item card">
          <h5>Start Shift 
            <!-- <small>({POINT} Points)</small> -->
          </h5>
          <span>{{rewardInfo?.start_shift?.reward_point || 0}} Points</span>
        </div>
        <div class="r-list-item card">
          <h5>End Shift 
            <!-- <small>({POINT} Points)</small> -->
          </h5>
          <span>{{rewardInfo?.end_shift?.reward_point || 0}} Points</span>
        </div>
        <!-- <ng-container *ngFor="let reward of rewardInfo?.loop || []">
          <div class="r-list-item card">
            <h5>Loop 
            </h5>
          <span>{{reward?.reward_point || 0}} Points</span>
          </div>
        </ng-container> -->
      </div>
    </kt-loader>

    <div class="modal-footer">
      <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
      </kt-button>
    </div>
  </div>
</kt-base-modal>